import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from '@mui/icons-material/Delete'
import React from "react"
import { ColumnContainer } from "utils/columnsStyle"
import { useDispatch } from "react-redux"

import { COUPONS_CONFIG } from "./config"
import { setSelectedPromocode } from "redux/actions/promocodes/promocodesActions"
import RegularButton from "components/CustomButtons/Button"

const blue = '#0055aa'

export const columns = [
    {
        Header: () => <span>{COUPONS_CONFIG.brand.label}</span>,
        accessor: COUPONS_CONFIG.brand.key,
        filterable: true,
        filterMethod: (filter, row) =>
            row[COUPONS_CONFIG.brand.key]
                ? row[COUPONS_CONFIG.brand.key]
                    .toLowerCase()
                    .includes(filter.value.toLowerCase())
                : "",
    },
    {
        Header: () => <span>{COUPONS_CONFIG.code.label}</span>,
        accessor: COUPONS_CONFIG.code.key,
        filterable: true,
        filterMethod: (filter, row) =>
            row[COUPONS_CONFIG.code.key]
                ? row[COUPONS_CONFIG.code.key]
                    .toLowerCase()
                    .includes(filter.value.toLowerCase())
                : "",
    },
    {
        Header: () => <span>{COUPONS_CONFIG.expDate.label}</span>,
        accessor: COUPONS_CONFIG.expDate.key,
        filterable: true,
        filterMethod: (filter, row) =>
            row[COUPONS_CONFIG.expDate.key]
                ? row[COUPONS_CONFIG.expDate.key]
                    .toLowerCase()
                    .includes(filter.value.toLowerCase())
                : "",
    },
    {
        Header: () => <span>{COUPONS_CONFIG.status.label}</span>,
        accessor: COUPONS_CONFIG.status.key,
        filterable: true,
        filterMethod: (filter, row) =>
            row[COUPONS_CONFIG.status.key]
                ? row[COUPONS_CONFIG.status.key]
                    .toLowerCase()
                    .includes(filter.value.toLowerCase())
                : "",
    },
    {
        Header: () => <span>{COUPONS_CONFIG.discount.label}</span>,
        accessor: COUPONS_CONFIG.discount.key,
        filterable: true,
        filterMethod: (filter, row) =>
            row[COUPONS_CONFIG.discount.key]
                ? row[COUPONS_CONFIG.discount.key]
                    .toLowerCase()
                    .includes(filter.value.toLowerCase())
                : "",
    },
    {
        Header: () => <span>{COUPONS_CONFIG.minPurchase.label}</span>,
        accessor: COUPONS_CONFIG.minPurchase.key,
        filterable: true,
        filterMethod: (filter, row) =>
            row[COUPONS_CONFIG.minPurchase.key]
                ? row[COUPONS_CONFIG.minPurchase.key]
                    .toLowerCase()
                    .includes(filter.value.toLowerCase())
                : "",
    },
    {
        Header: () => <span>Acciones</span>,
        filterable: false,
        sortable: false,
        Cell: ({ original }) => {
            const dispatch = useDispatch()
            const openEdit = () => {
                original.modal(true)
                dispatch(setSelectedPromocode({ promocode: original, addMode: false }))
            }

            const openDelete = () => {
                original.deleteModal(true)
                dispatch(setSelectedPromocode({ promocode: original, addMode: false }))
            }

            return (
                <ColumnContainer>
                    <RegularButton
                        tooltip={COUPONS_CONFIG.page.table.actions.delete}
                        round
                        justIcon
                        color="transparent"
                        size="sm"
                        onClick={openDelete}
                    >
                        <DeleteIcon style={{ color: blue[500] }} />
                    </RegularButton>
                    <RegularButton
                        tooltip={COUPONS_CONFIG.page.table.actions.edit}
                        round
                        justIcon
                        color="transparent"
                        size="sm"
                        onClick={openEdit}
                    >
                        <EditIcon style={{ color: blue[500] }} />
                    </RegularButton>
                </ColumnContainer>
            )
        },
    },
]
